import * as XLSX from "xlsx";

export function createExporter(filename, columns, mapRecord, references = []) {
    return async (records, dataProvider) => {
        const workbook = XLSX.utils.book_new();
        const safeRecords = Array.isArray(records) ? records : [];

        const relatedData = {};

        for (const ref of references) {
            const { source, target, name } = ref;

            const ids = Array.from(new Set(
                safeRecords
                    .flatMap(r => {
                        const val = r[source];
                        return Array.isArray(val) ? val : val ? [val] : [];
                    })
                    .filter(Boolean)
            ));

            if (ids.length === 0) {
                relatedData[name] = {};
                continue;
            }

            const { data } = await dataProvider.getMany(target, { ids });
            relatedData[name] = Object.fromEntries(data.map(item => [item.id, item]));
        }

        const enrichedRecords = safeRecords.map(record => {
            const r = { ...record };
            for (const ref of references) {
                const { source, name } = ref;
                const val = record[source];

                if (Array.isArray(val)) {
                    r[name] = val.map(id => relatedData[name][id]).filter(Boolean);
                } else {
                    r[name] = val ? relatedData[name][val] : null;
                }
            }
            return r;
        });

        const mapped = typeof mapRecord === "function"
            ? enrichedRecords.map(mapRecord)
            : enrichedRecords;

        const rows = mapped.map(record => {
            const row = {};
            columns.forEach(({ key, label }) => {
                row[label] = record[key] ?? "";
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(rows.length > 0 ? rows : [[]]);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
        XLSX.writeFile(workbook, filename);
    };
}